module.exports = __webpack_public_path__ + "media/img/about/social/email-56a138580a5847aa07893320427dfa6c.png";